import React, { ReactElement } from 'react';
import { InsetText, Text } from 'idsk-react-components';
import LegislativnyMaterialDetail from '../../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { StadiumMaterialuEnum } from '../../../../../model/legislativnyMaterial/StadiumMaterialu';
import mapDate from '../../../../../function/mapDate';
import '../LegMaterialPripomienkovanieMessage/legMaterialDetailMessage.scss';
import errorIcon from '../../../../../../assets/images/icon-error-red.svg';

interface Props {
  legMaterial: LegislativnyMaterialDetail;
}

const CAMUNDA_UPGRADE_RELEASE_DATE_DEFAULT = new Date('2026-05-14T22:00:00Z');

const parseReleaseDateOverride = (value: string | null): Date | null => {
  if (!value) return null;
  const dateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  const parsed = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

// eslint-disable-next-line max-len
export const CAMUNDA_UPGRADE_RELEASE_DATE = parseReleaseDateOverride(sessionStorage.getItem('CAMUNDA_UPGRADE_RELEASE_DATE'))
  ?? CAMUNDA_UPGRADE_RELEASE_DATE_DEFAULT;

const addCalendarDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const LegMaterialZapisStanoviskaMessage = ({ legMaterial }: Props): ReactElement => {
  const isNewProcess = legMaterial.datumVytvoreniaProcesu != null
    && legMaterial.datumVytvoreniaProcesu > CAMUNDA_UPGRADE_RELEASE_DATE;

  if (legMaterial.stadium.hodnota === StadiumMaterialuEnum.ZAPIS_PREDBEZNEHO_STANOVISKA
    && isNewProcess
    && legMaterial.hasOpravnenieSprievodneDokumenty) {
    return (
      <div className="material-detail-message-container">
        <InsetText
          id="zapisPredbStanoviskaWarning"
          type="warn"
          className="span-red__inset-text"
          icon={errorIcon}
        >
          <Text type="span" bold>
            Dokument typu „Predbežné stanovisko&rdquo; vložte do systému a následne vykonajte pracovný
            krok „Prechod do štádia Zápis doplneného predbežného stanoviska k návrhu aktu EÚ&rdquo;
            do {mapDate(addCalendarDays(legMaterial.datumVytvoreniaProcesu, 28))}.
            <br />
            V prípade predbežného stanoviska k návrhu aktu nelegislatívnej povahy môžete vykonať
            pracovný krok „Prechod do štádia Pripomienkové konanie&rdquo; alebo „Ukončiť proces bez
            odoslania do PK&rdquo;.
            <br />
            V prípade, ak do stanoveného dátumu vytvoríte aj dokument „Doplnené predbežné
            stanovisko&rdquo; a následne vykonáte pracovný krok „Prechod do štádia Pripomienkové
            konanie&rdquo; alebo „Ukončiť proces bez odoslania do PK&rdquo;, nie je potrebné prejsť
            do štádia „Zápis doplneného predbežného stanoviska k návrhu aktu EÚ&rdquo;.
            <br />
            V uvedených prípadoch bude automaticky odoslaná notifikácia NRSR.
          </Text>
        </InsetText>
      </div>
    );
  }

  if (legMaterial.stadium.hodnota === StadiumMaterialuEnum.ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA
    && isNewProcess
    && legMaterial.hasOpravnenieSprievodneDokumenty) {
    return (
      <div className="material-detail-message-container">
        <InsetText
          id="zapisDoplnenehoPredbStanoviskaWarning"
          type="warn"
          className="span-red__inset-text"
          icon={errorIcon}
        >
          <Text type="span" bold>
            Dokument typu „Doplnené predbežné stanovisko&rdquo; vložte do systému a následne vykonajte
            pracovný krok „Prechod do štádia Pripomienkové konanie&rdquo; alebo „Ukončiť proces bez
            odoslania do PK&rdquo; do {mapDate(addCalendarDays(legMaterial.datumVytvoreniaProcesu, 84))}.
            {' '}V oboch prípadoch bude automaticky odoslaná notifikácia NRSR.
          </Text>
        </InsetText>
      </div>
    );
  }

  return null;
};

export default LegMaterialZapisStanoviskaMessage;
